import React, { useState } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { FeaturesSection } from './components/FeaturesSection';
import { HowItWorksSection } from './components/HowItWorksSection';
import { PricingSection } from './components/PricingSection';
import { InvestorsSection } from './components/InvestorsSection';
import { CTASection } from './components/CTASection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { WaitlistForm } from './components/WaitlistForm';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);
  return <div className="flex flex-col min-h-screen bg-slate-50" data-id="element-0">
      <Navbar setIsFormOpen={setIsFormOpen} data-id="element-1" />
      <main className="flex-grow" data-id="element-2">
        <HeroSection setIsFormOpen={setIsFormOpen} data-id="element-3" />
        <FeaturesSection data-id="element-4" />
        <HowItWorksSection data-id="element-5" />
        <PricingSection setIsFormOpen={setIsFormOpen} data-id="element-6" />
        <InvestorsSection data-id="element-7" />
        <CTASection setIsFormOpen={setIsFormOpen} data-id="element-8" />
        <ContactSection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
      <WaitlistForm isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} data-id="element-11" />
      <ScrollToTop data-id="element-12" />
    </div>;
}